import { CircularProgress } from '@material-ui/core'

import React, { FC } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Loading: FC = () => (
  <Wrapper>
    <CircularProgress />
  </Wrapper>
)

export default Loading
